import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../../services/util/error.service'
import * as ResumoHttp from '../../../../../services/api/https/picking/resumo-separcao.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  ASSOCIANDO: 'Associando ocorrencias',
  SUCCESS: 'Ocorrências associadas com sucesso',
}

const INITIAL_STATE = {
  activeIndex: 0,
  btnAssociarDisabled: false,
  selectedPicking: null,
  errorMessage: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  sobrasItems: null,
  modal: { show: false, data: {} },
  ajusteOcorrenciaModal: { show: false, sobra: null },
}

export default function useSobras() {
  const [state, setState] = useState(INITIAL_STATE)

  const localDispatch = useMemo(() => {
    //Helpers
    const checkOcorrencias = sobrasItems => {
      const result = sobrasItems.find(f => f.missing_reason === '')
      if (result) {
        setState(prevState => ({
          ...prevState,
          errorMessage: `Existe(m) sobras sem ocorrência associada. Cliente ${result.company_code} - ${result.nome_fantasia}`,
        }))
      }
    }

    const buildDataFormatted = sobrasItems => {
      let result = []
      const r = sobrasItems.map(f => {
        return {
          sobra_id: f.leftover_id,
          missing_reason_id: f.missing_reason.id,
        }
      })
      result = [...result, ...r]
      return result
    }

    const checkIfBtnAssociarIsDisabled = selectedPicking => {
      return selectedPicking ? selectedPicking.status !== 'Picking Concluido' : false
    }

    return {
      // Actions
      associateOcorrencias(sobrasItems, selectedPicking) {
        checkOcorrencias(sobrasItems)
        const data = buildDataFormatted(sobrasItems)
        ResumoHttp.assocSobraOcorrencia(
          data.filter(d => d.missing_reason_id),
          selectedPicking,
        )
          .then(() =>
            setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SUCCESS })),
          )
          .catch(e =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(e),
              loadingMessage: null,
            })),
          )
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      // Events
      onInit(selectedPicking, sobrasItems) {
        setState(prevState => ({
          ...prevState,
          selectedPicking: selectedPicking,
          sobrasItems: sobrasItems,
          btnAssociarDisabled: checkIfBtnAssociarIsDisabled(selectedPicking),
        }))
      },

      onTabChange(e) {
        setState(prevState => ({ ...prevState, activeIndex: e.index }))
      },

      onDropdownChange(sobra, ocorrencia) {
        setState(prevState => {
          const index = prevState.sobrasItems.findIndex(s => s.leftover_id === sobra.leftover_id)
          if (index !== -1) {
            prevState.sobrasItems[index].missing_reason = ocorrencia
          }
          return { ...prevState }
        })
      },

      onBtnClicked() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.ASSOCIANDO }))
      },

      onVerFotosClicked(leftover_product) {
        setState(prevState => ({
          ...prevState,
          modal: { show: true, data: { fotos: leftover_product.files } },
          itemSelected: leftover_product,
        }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: {} } }))
      },

      onAjusteOcorrenciaClicked(sobra) {
        setState(prevState => ({
          ...prevState,
          ajusteOcorrenciaModal: { show: true, sobra },
        }))
      },

      onAjusteOcorrenciaModalClose() {
        setState(prevState => ({
          ...prevState,
          ajusteOcorrenciaModal: { show: false, sobra: null },
        }))
      },

      async onDeleteFoto(foto, selectedPicking) {
        try {
          await Promise.all([
            ResumoHttp.deleteLeftOverImage(selectedPicking.id, foto.id),
            ResumoHttp.deleteLeftOverFile(foto.url_image.split('/').pop()),
          ])

          setState(prevState => {
            const index = prevState.sobrasItems.findIndex(
              i => i.leftover_id === prevState.itemSelected.leftover_id,
            )
            if (index !== -1) {
              prevState.sobrasItems[index].files = prevState.sobrasItems[index].files.filter(
                f => f.id !== foto.id,
              )
            }
            return { ...prevState }
          })
        } catch (error) {
          setState(prevState => ({ ...prevState, errorMessage: error.message }))
        }
      },

      async onUploadCompleted(file_names, sobra, selectedPicking) {
        const savedFiles = await ResumoHttp.postFotosSobra(
          selectedPicking,
          sobra.leftover_id,
          file_names,
        )

        setState(prevState => {
          const index = prevState.sobrasItems.findIndex(i => i.leftover_id === sobra.leftover_id)
          if (index !== -1) {
            prevState.sobrasItems[index].files = [
              ...prevState.sobrasItems[index].files,
              ...savedFiles,
            ]
          }
          return { ...prevState }
        })
      },
    }
  }, [])

  return { state, localDispatch }
}
